import { client } from "./_base";

export const specialmarkets = client("specialmarket", item => ({
  ...item,
}));
